<template>
  <div class="modalbox modalStep" id="waypointModal">
    <!-- eslint-disable max-len-->
    <div class="is-flex bigmodal">
      <router-link :to="'/formation-apprenant/' +
        $route.params.idTraining +
        '/' +
        $route.params.idStudent +
        '/' +
        $route.params.idStudentTraining +
        '/waypoint'
        " class="btn-previous"><img class="btn-previous"
          :src="require('@/assets/img/arrows/previous.svg')" /></router-link>
      <router-link v-if="
        currentUser.role === 'formateur' ||
        currentUser.role === 'coordinateur'
      " class="ml-auto mr-2" :to="'/formations/' + $route.params.idTraining + '/suivi/validationSteps'
        ">
        <b-button type="is-outlined" rounded size="is-small">Formation</b-button>
      </router-link>
      <router-link class="mr-2" :to="'/formation-apprenant/' +
        $route.params.idTraining +
        '/' +
        $route.params.idStudent +
        '/' +
        $route.params.idStudentTraining +
        '/parcours'
        ">
        <b-button type="is-outlined" rounded size="is-small">Parcours</b-button>
      </router-link>
      <router-link :to="'/formation-apprenant/' +
        $route.params.idTraining +
        '/' +
        $route.params.idStudent +
        '/' +
        $route.params.idStudentTraining +
        '/waypoint'
        ">
        <b-button type="is-outlined" rounded size="is-small">Livret de suivi</b-button></router-link>
    </div>
    <b-loading :is-full-page="isFullPage" v-model="isLoading"> </b-loading>
    <section class="w-100 container">
      <div class="title-paragraph">
        {{ waypoint.name }}
      </div>
      <div class="studentName" v-if="currentUser.role !== 'apprenant' && booklet_validation.data">
        {{ this.booklet_validation.data[0].name }}
      </div>
      <div v-if="currentUser.role !== 'apprenant' && trainingStudents.length > 1" class="is-flex align-items-center justify-content-center mt-3 mb-3">
        <a
        :href="`/livret/${previousStudent.student_training_id}/${$route.params.idTraining}/${previousStudent.student_id}/${$route.params.idPart}`"
          v-if="previousStudent"
        >
          <b-button 
            type="is-primary is-outlined is-rounded" 
            size="is-small"
            icon-left="chevron-left"
          >
            {{ previousStudent.name }}
          </b-button>
        </a>
        <b-button 
          v-else
          type="is-primary is-outlined is-rounded" 
          size="is-small"
          icon-left="chevron-left"
          disabled
        >
          &nbsp;
        </b-button>
        <span class="mx-3 has-text-weight-bold">{{ currentStudentIndex + 1 }} / {{ trainingStudents.length }}</span>
        <a
          v-if="nextStudent"
          :href="`/livret/${nextStudent.student_training_id}/${$route.params.idTraining}/${nextStudent.student_id}/${$route.params.idPart}`"
        >
          <b-button 
            type="is-primary is-outlined is-rounded" 
            size="is-small"
            icon-right="chevron-right"
          >
            {{ nextStudent.name }}
          </b-button>
        </a>
        <b-button 
          v-else
          type="is-primary is-outlined is-rounded" 
          size="is-small"
          icon-right="chevron-right"
          disabled
        >
          &nbsp;
        </b-button>
      </div>
      <div class="has-text-centered mb-2">
        <b-tag type="is-success" v-if="this.validated === 'Effectué'">{{
          this.validated
        }}</b-tag>
        <b-tag type="is-primary" v-else-if="this.validated === 'En cours'">{{
          this.validated
        }}</b-tag>
        <b-tag type="is-danger is-light" v-else-if="this.validated === 'Litige'">{{ this.validated }}</b-tag>
        <b-tag type="is-outlined" v-else-if="this.validated === 'A faire'">{{
          this.validated
        }}</b-tag>
        <b-tag type="is-info" v-else>{{ this.validated }}</b-tag>
      </div>
      <div class="justify-content-center is-flex align-items-center">
        <span v-if="waypoint.due_datetime">
          A remplir entre le {{ waypoint.start_date | day }} et le {{ waypoint.due_datetime | day }}
        </span>
        <span v-else>
          A remplir à partir du {{ waypoint.start_date | day }}
        </span>
      </div>
      <div v-html="waypoint.helper" class="has-text-centered mb-4 mt-3" v-if="waypoint.helper"></div>
      <div v-if="json_form != null">
        <Survey :survey="survey" />
      </div>
      <div v-if="waypoint.resources" class="mt-4">
        <div v-if="waypoint.resources.length">
          <div v-for="resource in waypoint.resources" :key="resource.id">
            <ResourceCardSimple :resource="resource" :action="'read'"></ResourceCardSimple>
          </div>
        </div>
      </div>
      <div v-if="this.json_form == null">
        <div v-if="!idPatch">
          <div class="ck-editor-block mb-0 pb-0" style="display: none">
            <ckeditor v-model="formWaypoint.content" :editor="editor" :config="editorConfig" class="mb-5"
              :ref="'revisionContent'"></ckeditor>
          </div>
          <div v-html="formWaypoint.content"></div>
        </div>
        <div v-else>
          <div class="ck-editor-block mb-0 pb-0" style="display: none">
            <ckeditor v-model="formWaypoint.entry" :editor="editor" :config="editorConfig" class="mb-5"
              :ref="'revisionContent'"></ckeditor>
          </div>
          <div v-html="formWaypoint.entry"></div>
        </div>
      </div>
    </section>
    <div v-if="booklet_validation.data" class="container">
      <div class="cardValidation" v-if="booklet_validation.data[0].data[0].validations.length">
        <div class="mb-3">
          <b class="title-paragraph" style="font-size: 1.2rem">Validations attendues</b>
        </div>
        <div class="is-flex align-items-center justify-content-center">
          <div class="b-steps is-small w-100">
            <nav class="steps is-rounded">
              <ul class="step-items">
                <li class="step-item is-previous" v-for="validationItem in booklet_validation.data[0].data[0]
                  .validations" :key="validationItem.id">
                  <a class="step-link" 
                    v-if="currentUser.role === 'coordinateur' && currentUser.email != 'guhur-itii@cfaiprovence.com' && 
                          (!validationItem.validation_id || validationItem.status_label === 'A faire' || validationItem.status_label === 'En retard')"
                    @click="selectValidationForCoordinator(validationItem)"
                    style="cursor: pointer;">
                    <div class="step-marker">
                      <img v-if="validationItem.status_label == 'Valide'" :src="require(`@/assets/img/steps/status3.svg`)"
                        alt="" class="img_status mx-auto" />

                      <img v-else-if="validationItem.status_label == 'A faire'"
                        :src="require(`@/assets/img/steps/status6.svg`)" alt="" class="img_status mx-auto" />
                      <img v-else-if="validationItem.status_label == 'En retard'"
                        :src="require(`@/assets/img/steps/status-late.svg`)" alt="" class="img_status mx-auto" />
                      <img v-else :src="require(`@/assets/img/steps/status5.svg`)" alt="" class="img_status mx-auto" />
                    </div>
                    <div class="step-details">
                      <span class="step-title"> {{ validationItem.name }}</span>
                    </div>
                    <div class="mt-2">
                      <b-tag v-if="validationItem.status_label == 'Valide'" type="is-success">
                        {{ validationItem.status_label }}</b-tag>
                      <b-tag v-else-if="validationItem.status_label == 'A faire'" type="is-secondary is-outlined">
                        {{ validationItem.status_label }}</b-tag>
                      <b-tag v-else-if="validationItem.status_label == 'En retard'" class="is-outlined">
                        {{ validationItem.status_label }}</b-tag>
                      <b-tag v-else type="is-danger">
                        {{ validationItem.status_label }}</b-tag>
                      <div class="mt-2 datetime" v-if="validationItem.validation_datetime">
                        {{ validationItem.validation_datetime | day }}
                      </div>
                      <span class="step-name" v-if="validationItem.validator_name">
                        {{ validationItem.validator_name }}</span>
                      <div class="mt-2">
                        <small v-if="!isValidationAllowed(validationItem)" class="has-text-warning">⚠️ Validation bloquée</small>
                        <small v-else class="has-text-info">Cliquez pour valider</small>
                      </div>
                    </div>
                  </a>
                  <a class="step-link" v-else>
                    <div class="step-marker">
                      <img v-if="validationItem.status_label == 'Valide'" :src="require(`@/assets/img/steps/status3.svg`)"
                        alt="" class="img_status mx-auto" />

                      <img v-else-if="validationItem.status_label == 'A faire'"
                        :src="require(`@/assets/img/steps/status6.svg`)" alt="" class="img_status mx-auto" />
                      <img v-else-if="validationItem.status_label == 'En retard'"
                        :src="require(`@/assets/img/steps/status-late.svg`)" alt="" class="img_status mx-auto" />
                      <img v-else :src="require(`@/assets/img/steps/status5.svg`)" alt="" class="img_status mx-auto" />
                    </div>
                    <div class="step-details">
                      <span class="step-title"> {{ validationItem.name }}</span>
                    </div>
                    <div class="mt-2">
                      <b-tag v-if="validationItem.status_label == 'Valide'" type="is-success">
                        {{ validationItem.status_label }}</b-tag>
                      <b-tag v-else-if="validationItem.status_label == 'A faire'" type="is-secondary is-outlined">
                        {{ validationItem.status_label }}</b-tag>
                      <b-tag v-else-if="validationItem.status_label == 'En retard'" class="is-outlined">
                        {{ validationItem.status_label }}</b-tag>
                      <b-tag v-else type="is-danger">
                        {{ validationItem.status_label }}</b-tag>
                      <div class="mt-2 datetime" v-if="validationItem.validation_datetime">
                        {{ validationItem.validation_datetime | day }}
                      </div>
                      <span class="step-name" v-if="validationItem.validator_name">
                        {{ validationItem.validator_name }}</span>
                      <div class="mt-2" v-if="!isValidationAllowed(validationItem) && validationItem.status_label !== 'Valide'">
                        <small class="has-text-warning">⚠️ Validation précédente attendue</small>
                      </div>
                    </div>
                  </a>
                </li>
              </ul>
            </nav>

            <!---->
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="is-flex is-flex-wrap-wrap activityBtns align-items-center" style="z-index: 2000">
        <div class="w-100 is-flex">
          <div class="mx-auto is-flex">
            <span v-if="
              waypoint.editable && new Date(waypoint.start_date) < new Date()
            ">
              <span v-if="
                waypoint.editable.includes(currentUser.role) && validation
              ">
                <b-button v-if="
                  !validation.status_label ||
                  validation.status_label === 'A faire' ||
                  validation.status_label === 'En retard'
                " @click="gotoWaypointEdit()" class="btn-action w-auto mr-1" type="is-primary is-rounded is-outlined"
                  rounded>rédiger</b-button></span>
            </span>
            <span v-if="new Date(waypoint.start_date) < new Date()">
              <span v-if="validation && waypoint.start_date && (currentUser.role !== 'coordinateur')">
                <b-button v-if="
                  (!validation.status_label ||
                  validation.status_label === 'A faire' ||
                  validation.status_label === 'En retard') &&
                  (json_form == null || isSurveyValid) &&
                  canValidate
                " @click="validateBookletPart(1)" class="btn-action w-auto" type="is-success is-rounded"
                  rounded>valider</b-button>
                <span v-else-if="!canValidate" class="has-text-danger has-text-centered">
                  <b>Une validation précédente doit être effectuée avant que vous puissiez valider cette fiche</b>
                </span>
                <span v-if="validation.status_label === 'Valide'"
                  class="has-text-success has-text-centered is-flex align-items-center"><b>Vous avez validé cette
                    fiche</b>
                  <span v-if="
                    waypoint.editable.includes(currentUser.role) && validation
                  ">
                    <b-button v-if="this.validated !== 'Effectué'" @click="gotoWaypointEdit()" class="btn-action w-auto"
                      type="is-primary is-rounded is-outlined" rounded>modifier</b-button></span>
                </span>
                <span v-else-if="
                  this.validation.status_label === 'Non valide' &&
                  this.validation
                " class="has-text-danger has-text-centered"><b>Vous avez refusé de valider cette fiche</b>
                </span>
              </span>
              <span v-else-if="!validation || (currentUser.role === 'coordinateur' && !waypoint.editable.includes(currentUser.role))" class="subtitle-paragraph">Cette fiche est en lecture seule pour vous</span>
            </span>
            <span v-else><span v-if="validation">Cette fiche pourra être rédigée à partir du
                {{ waypoint.start_date | day }}</span>
              <span v-else class="subtitle-paragraph">Cette fiche sera éditée à partir du
                {{ waypoint.start_date | day }}. Elle est en lecture seule pour
                vous</span></span>
          </div>

          <div></div>
        </div>
        <div class="help-btn">
          <AppHelpMessage title="Modifiez votre point d'étape" message="Vous pouvez corriger une faute, ajouter un commentaire mais
             vous ne pouvez plus toucher aux expériences enregistrées une
              fois le point d'étape validé" textBtn="Besoin d'aide ?" />
        </div>
      </div>
    </div>

    <div class="container contentSequence pb-5 mb-5"></div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';
import CKEditor from '@ckeditor/ckeditor5-vue2';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import '@ckeditor/ckeditor5-build-classic/build/translations/fr';
import AppHelpMessage from '@/components/AppHelpMessage.vue';
import booklet from '@/components/Waypoints/booklet.json';
import _ from 'lodash';
import ResourceCardSimple from '@/components/Resources/ResourceCardSimple.vue';

// SurveyJs
import { Model } from 'survey-core';
import '@/assets/css/survey-core.defaultV2.css';
import { Survey } from 'survey-vue-ui';

export default ({
  filters: {
    day(date) {
      return moment(date).format('D/MM/YYYY');
    },
  },
  components: {
    AppHelpMessage,
    ckeditor: CKEditor.component,
    ResourceCardSimple,
    Survey,
  },
  computed: {
    ...mapState('auth', ['currentUser']),
    isSurveyValid() {
      // Vérifier si tous les champs obligatoires du Survey sont remplis
      // Utiliser surveyDataVersion pour forcer le recalcul quand les données changent
      // eslint-disable-next-line no-unused-vars
      const version = this.surveyDataVersion;
      
      if (!this.json_form || !this.survey) {
        return true; // Pas de Survey, pas de validation nécessaire
      }

      const allQuestions = this.survey.getAllQuestions();
      for (const question of allQuestions) {
        if (question.isRequired) {
          const value = this.survey.getValue(question.name);
          // Vérifier si la valeur est vide, null, undefined ou un tableau/objet vide
          const isEmpty = value === null || 
                         value === undefined || 
                         value === '' || 
                         (Array.isArray(value) && value.length === 0) ||
                         (typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0);
          
          if (isEmpty) {
            return false; // Un champ obligatoire est vide
          }
        }
      }
      
      return true; // Tous les champs obligatoires sont remplis
    },
    trainingStudents() {
      return this.$store.state.trainingStudents || [];
    },
    currentStudentIndex() {
      return this.trainingStudents.findIndex(
        student => student.student_training_id === Number(this.$route.params.idStudentTraining)
      );
    },
    previousStudent() {
      if (this.currentStudentIndex > 0) {
        return this.trainingStudents[this.currentStudentIndex - 1];
      }
      return null;
    },
    nextStudent() {
      if (this.currentStudentIndex >= 0 && this.currentStudentIndex < this.trainingStudents.length - 1) {
        return this.trainingStudents[this.currentStudentIndex + 1];
      }
      return null;
    },
    currentStudentName() {
      if (this.currentStudentIndex >= 0) {
        return this.trainingStudents[this.currentStudentIndex].name;
      }
      return '';
    },
    canValidate() {
      // Les coordinateurs et directeurs peuvent toujours valider
      if (this.currentUser.role === 'coordinateur' || this.isDirector) {
        return true;
      }

      // Vérifier si la validation courante est bloquée par une validation précédente
      if (!this.validation || !this.booklet_validation.data) {
        return true;
      }

      return this.isValidationAllowed(this.validation);
    },
  },
  watch: {
    '$route.params.idStudentTraining': {
      handler(newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
          // Recharger les données quand on change d'apprenant
          this.startLoading();
          this.initBookletPart();
        }
      },
    },
  },
  data() {
    return {
      idPatch: 0,
      isLoading: false,
      isFullPage: false,
      schoolSubjectsTraining: [],
      schoolSubjects: [],
      schoolSubjectsSelected: [],
      waypoint: [],
      arrayReports: [],
      student_activities_report: [],
      student_revisions_report: [],
      free_situations_report: [],
      formWaypoint: {
        id: '',
        title: '',
        comment: '',
        tutor_comment: '',
        teacher_comment: '',
        start_date: '',
        end_date: '',
        reports: [],
        validated: false,
      },
      checkboxCustom: [],
      activities: [],
      isOpenActivities: false,
      isOpenRevision: false,
      isOpenFree: false,
      editor: ClassicEditor,
      editorDisabled: true,
      editorConfig: {
        language: 'fr',
        toolbar: ['bold', 'italic', 'bulletedList', 'numberedList', '|', 'outdent', 'indent', '|', 'link', '|', 'undo',
          'redo'],
        alignment: {
          options: ['left', 'right'],
        },
        heading: {
          options: [
            { model: 'paragraph', title: 'Styles de texte', class: 'ck-heading_paragraph' },
            {
              model: 'heading1',
              view: 'h1',
              title: 'Titre 1',
              class: 'ck-heading_heading1',
            },
            {
              model: 'heading2',
              view: 'h2',
              title: 'Titre 2',
              class: 'ck-heading_heading2',
            },
            {
              model: 'mark',
              view: 'mark',
              title: 'surligné',
              class: 'ck-mark',
            },
          ],
        },
        table: {
          contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells'],
        },
      },
      bookletJson: booklet,
      booklet_validation: [],
      isDirector: false,
      validation: [],
      validated: false,
      survey: new Model(),
      json_form: null,
      surveyDataVersion: 0, // Pour forcer le recalcul de isSurveyValid
    };
  },
  methods: {
    startLoading() {
      this.isLoading = true;
    },
    endLoading() {
      this.isLoading = false;
    },
    initDirector() {
      this.$http
        .get(`/trainings/${this.$route.params.idTraining}/?query={directors}&format=json`)
        .then((response) => {
          const director = response.data.directors;
          if (director.includes(this.currentUser.id)) {
            this.isDirector = true;
          }
        });
    },
    initBookletPart() {
      const urlWs = `/get_booklet_part/${this.$route.params.idPart}?student_training=${this.$route.params.idStudentTraining}&format=json`;
      this.$http
        .get(`${urlWs}`)
        .then((response) => {
          this.waypoint = response.data;
          this.formWaypoint = this.waypoint;
          const entry = _.findIndex(this.waypoint.entries, ['student_training', Number(this.$route.params.idStudentTraining)]);
          if (entry !== -1) {
            this.formWaypoint.entry = this.waypoint.entries[entry].content;
            this.idPatch = this.waypoint.entries[entry].id;
          }
          this.initBookletValidation();
          this.endLoading();

          // SurveyJs
          this.json_form = response.data.form_structure;
          window.console.log(JSON.parse(this.json_form));
          if (this.json_form !== null) {
            this.survey = new Model(JSON.parse(this.json_form));
            this.survey.mode = 'display';

            // Charger les données existantes du Survey si elles existent
            if (this.formWaypoint.entry) {
              try {
                const existingData = JSON.parse(this.formWaypoint.entry);
                if (existingData && typeof existingData === 'object') {
                  Object.keys(existingData).forEach(key => {
                    this.survey.setValue(key, existingData[key]);
                  });
                  // Incrémenter la version pour forcer le recalcul de isSurveyValid
                  this.surveyDataVersion++;
                  console.log('Données du survey chargées depuis l\'entrée existante');
                }
              } catch (error) {
                console.error('Erreur lors du chargement des données du survey:', error);
              }
            }

            this.survey.onComplete.add((sender) => {
              window.console.log(JSON.stringify(sender.data, null, 3));
              this.postForm(JSON.stringify(sender.data));
            });
            // Fin SurveyJs
          }
        });
    },
    initBookletValidation() {
      this.startLoading();
      this.$http
        .get(`/get_training_booklet_validations/${this.$route.params.idTraining}?step=${this.$route.params.idPart}&student_training=${this.$route.params.idStudentTraining}`)
        .then((response) => {
          this.booklet_validation = response.data;
          this.validated = this.booklet_validation.data[0].data[0].user_status_label;
          
          // Si le rôle est coordinateur, il peut valider toutes les validations
          // On prend la première validation non validée ou la première disponible
          if (this.currentUser.role === 'coordinateur') {
            // Chercher une validation non validée
            const nonValidated = _.find(this.booklet_validation.data[0].data[0].validations,
              (v) => !v.validation_id || v.status_label === 'A faire' || v.status_label === 'En retard');
            if (nonValidated) {
              this.validation = nonValidated;
            } else {
              // Sinon prendre la première validation disponible
              this.validation = this.booklet_validation.data[0].data[0].validations[0];
            }
          } else if (this.isDirector) {
            const indexValidation = _.findKey(this.booklet_validation.data[0].data[0].validations,
              ['role', 'directeur']);
            this.validation = this.booklet_validation.data[0].data[0].validations[indexValidation];
          } else {
            const indexValidation = _.findKey(this.booklet_validation.data[0].data[0].validations,
              ['role', this.currentUser.role]);
            this.validation = this.booklet_validation.data[0].data[0].validations[indexValidation];
          }
        });
    },
    goPreviousPage() {
      this.$router.go(-1);
    },
    gotoActivity(id, sequenceId) {
      this.$router.push({
        name: 'StudentActivity',
        params: {
          idTraining: this.$route.params.idTraining,
          idStudentTraining: this.$route.params.idStudentTraining,
          idActivity: id,
          idSequence: sequenceId,
          from: this.$route.name,
          idStudent: this.$route.params.idStudent,
          idWaypoint: this.$route.params.idWaypoint,
        },
      });
    },
    gotoRevision(id, studentActivity) {
      const sequence = '1';
      this.$router.push({
        name: 'StudentProgressionRead',
        params: {
          idTraining: this.$route.params.idTraining,
          idStudentTraining: this.$route.params.idStudentTraining,
          idSequence: sequence,
          idActivity: studentActivity,
          idRevision: id,
          from: this.$route.name,
          idStudent: this.$route.params.idStudent,
          idWaypoint: this.$route.params.idWaypoint,
        },
      });
    },
    gotoFreeSituation(id) {
      this.$router.push({
        name: 'StudentFreeSituationRead',
        params: {
          idTraining: this.$route.params.idTraining,
          idStudentTraining: this.$route.params.idStudentTraining,
          idFree: id,
          from: this.$route.name,
          idStudent: this.$route.params.idStudent,
          idWaypoint: this.$route.params.idWaypoint,
        },
      });
    },
    gotoWaypointEdit() {
      this.$router.push({
        name: 'BookletPartEdit',
        params: {
          idTraining: this.$route.params.idTraining,
          idStudent: this.$route.params.idStudent,
          idStudentTraining: this.$route.params.idStudentTraining,
          idPart: this.$route.params.idPart,
        },
      });
    },
    validateBookletPart(statusValidation) {
      this.$buefy.dialog.confirm({
        title: 'Souhaitez-vous valider cette fiche ?',
        message: 'Vous êtes sur le point de valider cette fiche, vous confirmez que vous l\'avez bien relue. Toute modification sera ensuite impossible.',
        confirmText: 'Valider',
        cancelText: 'Relire',
        type: 'is-success',
        hasIcon: true,
        onConfirm: () => {
          if (this.idPatch) {
            this.postValidation(statusValidation);
          } else {
            this.$buefy.dialog.alert({
              title: 'Mince...',
              message: 'Pour valider l\'activité il faut que la fiche soit remplie',
              type: 'is-info',
              hasIcon: true,
              icon: 'times-circle',
              ariaRole: 'alertdialog',
              ariaModal: true,
              confirmText: 'Ok',
            });
          }
        },
      });
    },
    postValidation(statusValidation, identry, validationToUse = null) {
      // Si le rôle est coordinateur, utiliser le rôle de la validation à valider
      // Sinon utiliser le rôle de l'utilisateur
      let roleValidator = '';
      const validation = validationToUse || this.validation;
      
      if (this.currentUser.role === 'coordinateur') {
        // Le coordinateur valide avec le rôle de la validation qu'il valide
        roleValidator = validation.role;
      } else if (this.isDirector) {
        roleValidator = 'directeur';
      } else {
        roleValidator = this.currentUser.role;
      }
      
      if (!this.idPatch) {
        this.idPatch = identry;
      }
      this.$http
        .post('/validations/validation/', {
          role: roleValidator,
          student_training: Number(this.$route.params.idStudentTraining),
          simple_booklet_part_validation: validation.id,
          status: statusValidation,
        }).then(() => {
          this.$buefy.toast.open({
            message: 'La validation a bien été enregistrée',
            type: 'is-success',
          });
          this.goPreviousPage();
        }).catch((error) => {
          window.console.log(error);
          this.issue = true;
          this.$buefy.dialog.alert({
            title: 'Mince...',
            message: 'Votre validation n\'a pas pu être enregistrée',
            type: 'is-info',
            hasIcon: true,
            icon: 'times-circle',
            ariaRole: 'alertdialog',
            ariaModal: true,
            confirmText: 'Ok',
          });
        });
    },
    selectValidationForCoordinator(validationItem) {
      // Permettre au coordinateur de sélectionner une validation à valider
      // Afficher une modale de confirmation qui déclenche directement la validation
      this.$buefy.dialog.confirm({
        title: `Valider en tant que coordinateur`,
        message: `Vous êtes sur le point de valider cette fiche en tant que coordinateur à la place du rôle ${validationItem.role}. Confirmez-vous cette action ?`,
        confirmText: 'Valider',
        cancelText: 'Annuler',
        type: 'is-success',
        hasIcon: true,
        onConfirm: () => {
          // Valider directement avec le rôle de la validation sélectionnée
          this.postValidation(1, null, validationItem);
        },
      });
    },
    isValidationAllowed(validationItem) {
      // Les coordinateurs et directeurs peuvent toujours valider
      if (this.currentUser.role === 'coordinateur' || this.isDirector) {
        return true;
      }

      if (!this.booklet_validation.data || !this.booklet_validation.data[0].data[0].validations) {
        return true;
      }

      const validations = this.booklet_validation.data[0].data[0].validations;
      const currentPosition = validationItem.position;

      // Vérifier toutes les validations avec une position inférieure
      for (const validation of validations) {
        // Si la validation est avant la validation courante et qu'elle est bloquante
        if (validation.position < currentPosition && validation.blocking === true) {
          // Si cette validation bloquante n'est pas validée, bloquer la validation courante
          if (validation.status_label !== 'Valide') {
            return false;
          }
        }
      }

      return true;
    },
    loadTrainingStudents() {
      // Charger la liste des apprenants pour la navigation si elle n'est pas déjà dans le store
      if (!this.$store.state.trainingStudents || this.$store.state.trainingStudents.length === 0) {
        this.$http
          .get(`/get_training_booklet_validations/${this.$route.params.idTraining}?format=json`)
          .then((response) => {
            console.log('Loading students in BookletPartRead - API Response:', response.data);
            if (response.data && response.data.data && response.data.data.length > 0) {
              const students = response.data.data.map(student => ({
                name: student.name,
                student_id: student.student_id,
                student_training_id: student.student_training_id,
              }));
              // Trier par ordre alphabétique sur le nom
              students.sort((a, b) => a.name.localeCompare(b.name, 'fr', { sensitivity: 'base' }));
              console.log('Loading students in BookletPartRead - Extracted students (sorted):', students);
              this.$store.commit('GET_TRAINING_STUDENTS', students);
            } else {
              console.warn('No students data found in BookletPartRead');
            }
          })
          .catch((error) => {
            console.error('Error loading training students:', error);
          });
      }
    },
  },
  created() {
    this.startLoading();
    this.initBookletPart();
    this.initDirector();
    this.loadTrainingStudents();
  },
});
</script>

<style lang="scss" scoped>
.card_buttons {
  margin-left: auto !important;
  min-width: 198px;
}

.titles {
  max-width: 460px;
  padding-right: 1rem;
}

.studentName {
  font-weight: bold;
  font-size: 1.4rem;
  text-align: center;
}

@media screen and (max-width: 768px) {
  .card_activity::after {
    content: unset;
    color: #c1bbd0cc;
  }

  .card_activity {
    border-bottom: 1px solid #ededed;
  }

  .card_activity:last-child {
    border-bottom: 0px solid #ededed;

    &::after {
      content: unset;
    }
  }
}

@media screen and (max-width: 576px) {
  .content-steps {
    flex-direction: column;
  }

  .card_buttons {
    margin-left: 0px !important;
    padding-top: 0.5rem;
  }

  // .actions-icon,
  // .img_status {
  //   display: block;
  // }
  .titles {
    flex-direction: column;
  }
}
</style>
